export function VVGarageSettingsCtrl (
  $filter,
  $state,
  $scope,
  $translate,
  confirm,
  integration,
  messages,
  sessionObjAPI,
  vv_garage_locations,
  workshopAPI
) {
  $scope.integration         = integration;
  $scope.vv_garage_locations = vv_garage_locations || [];
  $scope.vv_garage_location  = $filter('filter')($scope.vv_garage_locations, { LocationID: $scope.integration.vv_garage_location_id })[0] || '';

  $scope.activate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: 'VV Garage' }))
    .then(() => workshopAPI.get('/company_integration/add_vv_garage'))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: 'VV Garage' }), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.remove = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.REMOVE', { name: 'VV Garage' }))
    .then(() => workshopAPI.get('/company_integration/remove_vv_garage'))
    .then(() => sessionObjAPI.refresh())
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.REMOVED', { name: 'VV Garage' }), 'success');
      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.save = function (form) {
    $scope.integration.vv_garage_location_id = $scope.vv_garage_location.LocationID;

    workshopAPI.patch('/company_integrations', $scope.integration, 'company_integration')
    .then(() => sessionObjAPI.refresh())
    .then(data => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };
}
